module.exports = __webpack_public_path__ + "media/assets/images/category/Sorry@2x-2edb901cb47ae1f4ad5218f24c8abe5a.png";